import emptySliceApi from '../../store/emptyApiSlice';

export const apiSlice = emptySliceApi.injectEndpoints({
  endpoints: (builder) => ({
    getProfileImageUrl: builder.query<{ url: string }, void>({
      query: () => '/profile/profileImageUrl',
    }),
  }),
});

export const { useGetProfileImageUrlQuery } = apiSlice;
